// src/plugins/asset.ts
import {PluginFunction} from 'vue';

const publicPath = process.env.BASE_URL || '/';

export function prefixPublicAsset(path: string): string {
  if (!path.startsWith('/')) {
    path = '/' + path;
  }

  return publicPath.replace(/\/$/, '') + path;
}

declare module 'vue/types/vue' {
  interface Vue {
    $publicAsset: (path: string) => string;
  }
}

export const PublicAssetPlugin: PluginFunction<any> = (Vue) => {
  Vue.prototype.$publicAsset = prefixPublicAsset;
};
